import { getGeneralBreadcrumbs } from "Helpers/generalBreadcrumbs";
import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";
import { getBusinessSetupBreadcrumbs } from "Helpers/businessSetupBreadcrumbs";
import { getItemsBreadcrumbs } from "Helpers/itemsBreadcrumbs";
import { getVehiclesBreadcrumbs } from "Helpers/vehiclesBreadcrumbs";
import { getCustomersBreadcrumbs } from "Helpers/customersBreadcrumbs";
import { getSuppliersBreadcrumbs } from "Helpers/suppliersBreadcrumbs";
import { getStationsBreadcrumbs } from "Helpers/stationsBreadcrumbs";
import { getInventoryBreadcrumbs } from "Helpers/inventoryBreadcrumbs";

export const resolvePageBreadcrumbs = (
  pathname: string,
): BreadcrumbItem[] | null =>
  getGeneralBreadcrumbs(pathname) ??
  getBusinessSetupBreadcrumbs(pathname) ??
  getItemsBreadcrumbs(pathname) ??
  getVehiclesBreadcrumbs(pathname) ??
  getCustomersBreadcrumbs(pathname) ??
  getSuppliersBreadcrumbs(pathname) ??
  getStationsBreadcrumbs(pathname) ??
  getInventoryBreadcrumbs(pathname);
